import React, { useState } from 'react';
import { useApp } from '../context/AppContext';

interface LogoProps {
  size?: number;
  className?: string;
  showText?: boolean;
}

const Logo: React.FC<LogoProps> = ({ size = 32, className = "", showText = false }) => {
  const { appSettings } = useApp();
  const [imgError, setImgError] = useState(false);

  // If a custom logo is provided in settings and hasn't errored out
  if (appSettings.appLogo && !imgError) {
    return (
      <div className={`inline-flex flex-col items-center justify-center select-none ${className}`}>
        <img 
          src={appSettings.appLogo} 
          alt={appSettings.appName} 
          style={{ width: size, height: size, objectFit: 'contain' }}
          className="rounded-lg shadow-sm"
          onError={() => setImgError(true)}
        />
        {showText && (
          <div className="text-center leading-none mt-2">
            <span className="block font-extrabold text-gray-800 dark:text-white tracking-tight uppercase" style={{ fontSize: Math.max(10, size * 0.35), fontFamily: 'sans-serif' }}>
              {appSettings.appName}
            </span>
          </div>
        )}
      </div>
    );
  }

  return (
    <div className={`inline-flex flex-col items-center justify-center select-none ${className}`}>
      <svg 
        width={size} 
        height={size} 
        viewBox="0 0 512 512" 
        fill="none" 
        xmlns="http://www.w3.org/2000/svg"
        className="overflow-visible"
      >
        {/* Teal Arc (Top Left) */}
        <path 
          d="M256 60C147.8 60 60 147.8 60 256C60 293.4 70.4 328.4 88.5 358L157.7 318C149.6 300 145 278.5 145 256C145 194.7 194.7 145 256 145V60Z" 
          fill="#2DD4BF" 
          fillOpacity="0.9"
        />
        
        {/* Lime Arc (Top Right) */}
        <path 
          d="M256 60V145C317.3 145 367 194.7 367 256C367 278.5 362.4 300 354.3 318L423.5 358C441.6 328.4 452 293.4 452 256C452 147.8 364.2 60 256 60Z" 
          fill="#A3E635" 
          fillOpacity="0.7"
        />

        {/* Emerald Arc (Bottom) */}
        <path 
          d="M423.5 358L354.3 318C334.8 358.5 293.7 386.5 246 386.5C198.3 386.5 157.2 358.5 137.7 318L68.5 358C103.5 423.5 174.5 471.5 256 471.5C337.5 471.5 408.5 423.5 443.5 358L423.5 358Z" 
          fill="#059669"
        />
      </svg>
      
      {showText && (
          <div className="text-center leading-none mt-2">
              <span className="block font-extrabold text-gray-800 dark:text-white tracking-tight uppercase" style={{ fontSize: Math.max(10, size * 0.35), fontFamily: 'sans-serif' }}>
                {appSettings.appName}
              </span>
          </div>
      )}
    </div>
  );
};

export default Logo;